export default "__VITE_PUBLIC_ASSET__9af02821__"